// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";

function of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.albumCount;
  const v$1 = x.coverArt;
  const v$2 = x.id;
  const v$3 = x.musicBrainzId;
  const v$4 = x.name;
  const v$5 = x.starred;
  const v$6 = x.userRating;
  return {
    albumCount: v !== undefined ? Ppx_deriving_json_runtime.Primitives.int_of_json(v) : Ppx_deriving_json_runtime.of_json_error("missing field \"albumCount\""),
    coverArt: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"coverArt\""),
    id: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$2) : Ppx_deriving_json_runtime.of_json_error("missing field \"id\""),
    musicBrainzId: v$3 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$3) : undefined,
    name: v$4 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$4) : Ppx_deriving_json_runtime.of_json_error("missing field \"name\""),
    starred: v$5 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$5) : undefined,
    userRating: v$6 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$6) : undefined
  };
}

function to_json(x) {
  return {
    albumCount: x.albumCount,
    coverArt: x.coverArt,
    id: x.id,
    musicBrainzId: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.musicBrainzId),
    name: x.name,
    starred: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.starred),
    userRating: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.userRating)
  };
}

export {
  of_json,
  to_json,
}
/* No side effect */
